const NewsGridSchema = (props) => {
  const mode = props?.data?.mode || 'auto';
  let sourceFieldset;
  if (mode === 'manual') {
    sourceFieldset = {
      id: 'source',
      title: 'Itens selecionados',
      fields: ['items'],
    };
  } else if (mode === 'query') {
    sourceFieldset = {
      id: 'source',
      title: 'Query avançada',
      fields: ['query'],
    };
  } else {
    sourceFieldset = {
      id: 'source',
      title: 'Origem automática',
      fields: ['parentPath', 'portalTypes', 'sortOn', 'limit'],
    };
  }

  return {
    title: 'AgSUS News Grid',
    fieldsets: [
      {
        id: 'default',
        title: 'Geral',
        fields: [
          'mode',
          'eyebrow',
          'title',
          'linkText',
          'linkHref',
          'columns',
          'layout',
          'imagePosition',
        ],
      },
      sourceFieldset,
    ],
    properties: {
      mode: {
        title: 'Modo de seleção',
        choices: [
          ['auto', 'Automático (últimas da pasta)'],
          ['manual', 'Manual (escolher itens)'],
          ['query', 'Query avançada (igual Search padrão)'],
        ],
        default: 'auto',
      },
      title: {
        title: 'Título da seção',
        default: 'Últimas notícias',
      },
      eyebrow: {
        title: 'Etiqueta',
        description: 'Label decorativa acima do título',
      },
      linkText: {
        title: 'Texto do link à direita do título',
        description:
          'Opcional. Ex.: Veja todos os comunicados. Aparece só com o texto e o endereço preenchidos.',
      },
      linkHref: {
        title: 'Endereço do link',
        description:
          'Página do site (ex.: /noticias/comunicados) ou endereço externo (https://…).',
      },
      columns: {
        title: 'Colunas',
        choices: [
          ['2', '2'],
          ['3', '3'],
          ['4', '4'],
        ],
        default: '3',
      },
      layout: {
        title: 'Disposição',
        choices: [
          ['grid', 'Grid uniforme'],
          ['featured', 'Destaque + secundários'],
          [
            'stack',
            'Stack (imagem à esquerda + texto vertical) — pra Veja Também',
          ],
        ],
        default: 'grid',
      },
      imagePosition: {
        title: 'Foco da imagem',
        description:
          'Onde a imagem deve ser centralizada quando precisa ser cortada. Aplica a todos os cards deste bloco.',
        choices: [
          ['top', 'Topo'],
          ['center', 'Centro (padrão)'],
          ['bottom', 'Base'],
        ],
        default: 'center',
      },
      parentPath: {
        title: 'Pasta de origem',
        description: 'Path absoluto, ex: /noticias',
        default: '/noticias',
      },
      portalTypes: {
        title: 'Tipos de conteúdo',
        choices: [['News Item', 'Notícia']],
        isMulti: true,
        default: ['News Item'],
      },
      sortOn: {
        title: 'Ordenar por',
        choices: [
          ['effective', 'Data de publicação (mais recente)'],
          ['created', 'Data de criação'],
          ['sortable_title', 'Título'],
        ],
        default: 'effective',
      },
      limit: {
        title: 'Número de itens',
        type: 'integer',
        default: 6,
      },
      items: {
        title: 'Itens',
        description:
          'Cada item escolhe uma notícia e pode sobrescrever título, descrição, proporção e foco da imagem. Ordem aqui = ordem de exibição.',
        widget: 'object_list',
        schema: {
          title: 'Item',
          fieldsets: [
            {
              id: 'default',
              title: 'Padrão',
              fields: [
                'target',
                'customTitle',
                'customDescription',
                'imageRatio',
                'imagePosition',
              ],
            },
          ],
          properties: {
            target: {
              title: 'Notícia',
              widget: 'object_browser',
              mode: 'link',
              allowExternals: false,
              selectableTypes: ['News Item'],
            },
            customTitle: {
              title: 'Título customizado',
              description: 'Opcional — sobrescreve o título original.',
            },
            customDescription: {
              title: 'Descrição customizada',
              description: 'Opcional — sobrescreve a descrição original.',
              widget: 'textarea',
            },
            imageRatio: {
              title: 'Proporção da imagem',
              choices: [
                ['', 'Automática (default do bloco)'],
                ['4 / 3', '4:3'],
                ['16 / 9', '16:9 widescreen'],
                ['3 / 2', '3:2'],
                ['1 / 1', '1:1 quadrada'],
                ['3 / 4', '3:4 retrato'],
              ],
              default: '',
            },
            imagePosition: {
              title: 'Foco da imagem',
              choices: [
                ['', 'Padrão do bloco'],
                ['top', 'Topo'],
                ['center', 'Centro'],
                ['bottom', 'Base'],
              ],
              default: '',
            },
          },
          required: ['target'],
        },
      },
      query: {
        title: 'Consulta',
        description:
          'Filtros, ordenação e paginação — mesmo widget do Listing/Search padrão',
        widget: 'querystring',
      },
    },
    required: [],
  };
};

export default NewsGridSchema;
